import {
  READ_PHT_TIMELINE_COMPLETE,
  READ_PHT_TIMELINE_ERROR,
  READ_PHT_TIMELINE_START,
  READ_PHT_TIMELINE_SUCCESS,
} from 'src/shared/phtTimeline/actions';
import {createResourceReducer} from 'src/shared/utils/resource';

export const phtTimeline = createResourceReducer({
  start: READ_PHT_TIMELINE_START,
  success: READ_PHT_TIMELINE_SUCCESS,
  error: READ_PHT_TIMELINE_ERROR,
  complete: READ_PHT_TIMELINE_COMPLETE,
});
